import { render, staticRenderFns } from "./ScreenCountry.vue?vue&type=template&id=67b0b0a1&scoped=true&"
import script from "./ScreenCountry.vue?vue&type=script&lang=js&"
export * from "./ScreenCountry.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCountry.vue?vue&type=style&index=0&id=67b0b0a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0b0a1",
  null
  
)

export default component.exports